import api from '@/api';

interface MenuAuth {
    menuId: Number,
    roleId: Number,
    read: boolean,
    write: boolean,
    update: boolean,
    delete: boolean,
    print: boolean
}

interface MenuAuthResponse extends MenuAuth {
    roleName: String
}

export default {
    getMenuAuthList: (menuId: Number): Promise<MenuAuthResponse[]> => {
        return api.get({
            url: '/Common/Menu/api/getmenuauth',
            params: {
                MenuId: menuId
            }
        });
    },
}